/* APW Theme JS — 只做兩件事：咖啡豆列箭頭捲動、手機導覽開合 */
(function () {
  function initRowArrow(root) {
    root.querySelectorAll('[data-apw-row-next]').forEach(function (btn) {
      var row = btn.closest('[data-apw-row-wrap]').querySelector('.apw-row');
      if (!row) return;
      btn.addEventListener('click', function () {
        row.scrollBy({ left: Math.round(row.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
  }
  function initBurger(root) {
    root.querySelectorAll('[data-apw-burger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var menu = document.querySelector('[data-apw-mobile-nav]');
        if (menu) menu.classList.toggle('is-open');
      });
    });
  }
  function boot(root) { initRowArrow(root); initBurger(root); }
  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  // Theme editor：section 重新載入時重新綁定
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
